import React, { useState } from "react";
import {
  MainDiv,
  Container,
  LogoImage,
  LoginForm,
  Input,
  Header1,
  List,
  BulletPoints,
  Anchor,
  Message,
  ButtonIcon,
  IconContainer,
  CheklistWrapper,
  LoginMessage,
} from "./styles";
import { postRegister } from "../../services/user/postActions";
import { useToasts } from "react-toast-notifications";
import { useNavigate } from "react-router-dom";
import HubReserveLogo from "../../assets/hub-reserve-text.png";
import {
  Button,
  FormControlLabel,
  IconButton,
  Switch,
  TextField,
} from "@mui/material";
import { ROUTES } from "../../routes/constants";
import Spinner from "../../components/Spinner/Spinner";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import PasswordStrengthBar from "react-password-strength-bar";
import PasswordChecklist from "react-password-checklist";

const Register = () => {
  const { addToast } = useToasts();
  const navigate = useNavigate();

  // ------------------- STATES -------------------
  const [userName, setUserName] = useState("");
  const [userLastName, setUserLastName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userPwd, setUserPwd] = useState("");
  const [userVerPwd, setUserVerPwd] = useState("");
  const [loadingRegister, setLoadingRegister] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showVerPassword, setShowVerPassword] = useState(false);
  const [acceptPolicies, setAcceptPolicies] = useState(false);

  // ------------------- REGISTER REQUEST -------------------
  const accessRegister = async (event: any) => {
    // Preventing that the form sends the information
    event.preventDefault();

    // ------------------- REQUIREMENTS VALIDATION -------------------
    const passwordValidationRegex = /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$+%^&*.])/;
    const passwordValidation = passwordValidationRegex.test(userPwd);
    const emailValidation = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userEmail);
    if (!emailValidation) {
      addToast("El email es inválido", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    } else if (!passwordValidation) {
      addToast("La contraseña no es segura", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    } else if (userPwd.length < 8) {
      addToast("La contraseña debe tener al menos 8 caracteres", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    } else if (userPwd !== userVerPwd) {
      addToast("Las contraseñas no coinciden", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    } else if (!acceptPolicies) {
      addToast("Debes aceptar las políticas de privacidad", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    }

    const atIndex = userEmail.indexOf("@");
    const organization = userEmail.substring(atIndex + 1);
    setLoadingRegister(true);
    await postRegister(userName, userLastName, userEmail, userPwd, organization)
      .then((res) => {
        if (res.status > 299) {
          addToast("Favor de verificar sus datos", {
            appearance: "error",
            autoDismiss: true,
          });
        } else {
          addToast("Registro exitoso, favor de verificar su correo", {
            appearance: "success",
            autoDismiss: true,
          });
          navigate(`${ROUTES.LOGIN}`);
        }
        setLoadingRegister(false);
      })
      .catch((err) => {
        setLoadingRegister(false);
        addToast("Ocurrió un error, favor de verificar credenciales", {
          appearance: "error",
          autoDismiss: true,
        });
      });
  };

  // ------------------- PASSWORD HANDLER -------------------
  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  // ------------------- VERIFICATION PASSWORD HANDLER -------------------
  const toggleShowVerPassword = () => {
    setShowVerPassword(!showVerPassword);
  };

  // ------------------- POLICIES HANDLER -------------------
  const toggleAcceptPolicies = () => {
    setAcceptPolicies(!acceptPolicies);
  };

  return (
    <>
      {loadingRegister ? (
        <Spinner />
      ) : (
        <MainDiv>
          <Container>
            <LogoImage src={HubReserveLogo} alt="Hub Reserve Logo" />

            <Header1>Registro</Header1>

            <LoginForm onSubmit={accessRegister}>
              {/* <Input
                type="text"
                name="name"
                placeholder="Nombre(s)"
                required
                value={userName}
                onChange={(event) => setUserName(event.target.value)}
              /> */}
              <TextField
                label="Nombre(s)"
                value={userName}
                variant="outlined"
                fullWidth
                required
                onChange={(event) => setUserName(event.target.value)}
                sx={{ margin: "15px 0" }}
                InputProps={{
                  style: {
                    borderRadius: "14px",
                  },
                }}
              />
              {/* <Input
                type="text"
                name="lastname"
                placeholder="Apellido(s)"
                required
                value={userLastName}
                onChange={(event) => setUserLastName(event.target.value)}
              /> */}
              <TextField
                label="Apellido(s)"
                value={userLastName}
                variant="outlined"
                fullWidth
                required
                onChange={(event) => setUserLastName(event.target.value)}
                sx={{ margin: "15px 0" }}
                InputProps={{
                  style: {
                    borderRadius: "14px",
                  },
                }}
              />
              {/* <Input
                type="email"
                name="email"
                placeholder="Correo electrónico"
                required
                value={userEmail}
                onChange={(event) => setUserEmail(event.target.value)}
              /> */}
              <TextField
                label="Correo electrónico"
                value={userEmail}
                variant="outlined"
                fullWidth
                required
                onChange={(event) => setUserEmail(event.target.value)}
                sx={{ margin: "15px 0" }}
                InputProps={{
                  style: {
                    borderRadius: "14px",
                  },
                }}
              />
              {/* <IconContainer>
                <ButtonIcon type="button" onClick={toggleShowPassword}>
                  {!showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </ButtonIcon>
                <Input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Contraseña"
                  required
                  value={userPwd}
                  onChange={(event) => setUserPwd(event.target.value)}
                />
              </IconContainer> */}
              <TextField
                label="Contraseña"
                type={showPassword ? "text" : "password"}
                variant="outlined"
                value={userPwd}
                onChange={(event) => setUserPwd(event.target.value)}
                fullWidth
                required
                sx={{ margin: "15px 0" }}
                InputProps={{
                  style: {
                    borderRadius: "14px",
                  },
                  endAdornment: (
                    <IconButton
                      onClick={toggleShowPassword}
                      sx={{
                        minWidth: 0,
                        borderRadius: "30px",
                        background: "transparent",
                      }}
                    >
                      {showPassword ? (
                        <Visibility style={{ color: "A9A9A9" }} />
                      ) : (
                        <VisibilityOff style={{ color: "A9A9A9" }} />
                      )}
                    </IconButton>
                  ),
                }}
              />
              <PasswordStrengthBar
                password={userPwd}
                scoreWords={["Muy débil", "Débil", "Okay", "Buena", "Fuerte"]}
                shortScoreWord={"Muy corta"}
              />
              {/* <IconContainer>
                <ButtonIcon type="button" onClick={toggleShowVerPassword}>
                  {!showVerPassword ? (
                    <VisibilityOffIcon />
                  ) : (
                    <VisibilityIcon />
                  )}
                </ButtonIcon>
                <Input
                  type={showVerPassword ? "text" : "password"}
                  name="password"
                  placeholder="Contraseña (confirmación)"
                  required
                  value={userVerPwd}
                  onChange={(event) => setUserVerPwd(event.target.value)}
                />
              </IconContainer> */}

              <TextField
                label="Contraseña (confirmación)"
                type={showVerPassword ? "text" : "password"}
                variant="outlined"
                value={userVerPwd}
                onChange={(event) => setUserVerPwd(event.target.value)}
                fullWidth
                required
                sx={{ margin: "25px 0" }}
                InputProps={{
                  style: {
                    borderRadius: "14px",
                  },
                  endAdornment: (
                    <IconButton
                      onClick={toggleShowVerPassword}
                      sx={{
                        minWidth: 0,
                        borderRadius: "30px",
                        background: "transparent",
                      }}
                    >
                      {showVerPassword ? (
                        <Visibility style={{ color: "A9A9A9" }} />
                      ) : (
                        <VisibilityOff style={{ color: "A9A9A9" }} />
                      )}
                    </IconButton>
                  ),
                }}
              />
              <CheklistWrapper>
                <PasswordChecklist
                  rules={[
                    "minLength",
                    "specialChar",
                    "number",
                    "capital",
                    "match",
                  ]}
                  minLength={5}
                  value={userPwd}
                  valueAgain={userVerPwd}
                  messages={{
                    minLength: "La contraseña tiene más de 8 caracteres.",
                    specialChar:
                      "La contraseña tiene al menos un caracter especial.",
                    number: "La contraseña tiene al menos un número.",
                    capital:
                      "La contraseña tiene al menos una letra mayúscula.",
                    match: "Las contraseñas coinciden.",
                  }}
                />
              </CheklistWrapper>
              {/* <List>
                <BulletPoints>
                  Debe contener al menos una letra en mayúscula.
                </BulletPoints>
                <BulletPoints>
                  Debe contener al menos un dígito numérico.
                </BulletPoints>
                <BulletPoints>
                  Debe contener al menos un caracter especial.
                </BulletPoints>
                <BulletPoints>Longitud mínima de 8 caratceres.</BulletPoints>
              </List> */}

              <FormControlLabel
                control={<Switch onChange={toggleAcceptPolicies} />}
                label={
                  <Message>
                    Estoy de acuerdo con los{" "}
                    <Anchor
                      href={ROUTES.POLICIES}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Términos de servicio y Políticas de Privacidad
                    </Anchor>
                  </Message>
                }
              />

              {/* <Button type="submit">Registrarse</Button> */}
              <Button
                variant="contained"
                onClick={accessRegister}
                sx={{
                  borderRadius: "12px",
                  fontSize: "18px",
                  backgroundColor: "#13314D",
                  padding: "10px 10%",
                  color: "#FFF",
                  textTransform: "none",
                  marginTop: "20px",
                  "&:hover": {
                    backgroundColor: "#111E2F",
                  },
                }}
              >
                Registrarse
              </Button>

              <LoginMessage>
                ¿Ya estás registrado?{" "}
                <Anchor href={ROUTES.LOGIN}>Inicia sesión</Anchor>
              </LoginMessage>
            </LoginForm>
          </Container>
        </MainDiv>
      )}
    </>
  );
};

export default Register;
